import { getProjectConfigurationsApi, createProjectConfigurationsApi, editProjectConfigurationsApi, deleteProjectConfigurationsApi, } from '../api/configurations';
const configurationsActions = {
    getConfigurations: async ({ projectId }, { setState }) => {
        try {
            const { data: res } = await getProjectConfigurationsApi(projectId);
            setState((state) => {
                if (state.project.data) {
                    state.project.data.configurations = res;
                }
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    createConfigurations: async ({ projectId, data }) => {
        try {
            const { data: res } = await createProjectConfigurationsApi(projectId, data);
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data?.errors;
        }
    },
    editConfigurations: async ({ projectId, data }) => {
        try {
            const { data: res } = await editProjectConfigurationsApi(projectId, data);
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data?.errors;
        }
    },
    deleteConfigurations: async ({ projectId, configurationIds }) => {
        try {
            await deleteProjectConfigurationsApi(projectId, configurationIds);
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
};
export default configurationsActions;
